/**
 * Laufzeitkonfiguration der SPA aus den Vite-Variablen (gesetzt von SST beim Build).
 * Der Entwicklungsmodus ohne Cognito existiert nur im Vite-Dev-Server: Im Build ist
 * `import.meta.env.DEV` konstant `false`, der Zweig und der Dev-Login fallen weg.
 */
export type AuthMode = 'cognito' | 'dev';

export interface AppConfig {
  authMode: AuthMode;
  apiUrl: string;
  cognito: { region: string; clientId: string };
}

export function readConfig(): AppConfig {
  if (import.meta.env.DEV && import.meta.env['VITE_AUTH_MODE'] === 'dev') {
    return { authMode: 'dev', apiUrl: '/api', cognito: { region: '', clientId: '' } };
  }
  const apiUrl = String(import.meta.env['VITE_API_URL'] ?? '').replace(/\/$/, '');
  const region = String(import.meta.env['VITE_COGNITO_REGION'] ?? '');
  const clientId = String(import.meta.env['VITE_COGNITO_CLIENT_ID'] ?? '');
  if (!apiUrl || !region || !clientId) throw new Error('Konfiguration unvollständig: VITE_API_URL, VITE_COGNITO_REGION, VITE_COGNITO_CLIENT_ID');
  return { authMode: 'cognito', apiUrl, cognito: { region, clientId } };
}
